export var DeviceEntities;
(function (DeviceEntities) {
    DeviceEntities["heating_circuits"] = "heating_circuits";
    DeviceEntities["boiler_heating_circuits"] = "boiler_heating_circuits";
    DeviceEntities["heating_modes"] = "heating_modes";
    DeviceEntities["boiler_heating_modes"] = "boiler_heating_modes";
    DeviceEntities["simple_view"] = "simple_view";
    DeviceEntities["thermometers"] = "thermometers";
    DeviceEntities["sensors"] = "sensors";
    DeviceEntities["custom_controls"] = "custom_controls";
    DeviceEntities["guard_controls"] = "guard_controls";
    DeviceEntities["guard_zones"] = "guard_zones";
    DeviceEntities["vehicle_controls"] = "vehicle_controls";
    DeviceEntities["vehicle_custom_controls"] = "vehicle_custom_controls";
    DeviceEntities["rf_indicators"] = "rf_indicators";
    DeviceEntities["terminal"] = "terminal";
})(DeviceEntities || (DeviceEntities = {}));
export const device_entities_name = {
    [DeviceEntities.heating_circuits]: 'Отопительные контуры',
    [DeviceEntities.boiler_heating_circuits]: 'Котловые контуры',
    [DeviceEntities.heating_modes]: 'Отопительные режимы',
    [DeviceEntities.boiler_heating_modes]: 'Котловые режимы',
    [DeviceEntities.simple_view]: 'Упрощенный режим',
    [DeviceEntities.thermometers]: 'Температура',
    [DeviceEntities.sensors]: 'Датчики',
    [DeviceEntities.custom_controls]: 'Управление и статус',
    [DeviceEntities.guard_controls]: 'Управление охраной',
    [DeviceEntities.guard_zones]: 'Охрана',
    [DeviceEntities.vehicle_controls]: 'Управление транспортом',
    [DeviceEntities.vehicle_custom_controls]: 'Управление и статус',
    [DeviceEntities.rf_indicators]: 'Радиоустройства',
    [DeviceEntities.terminal]: 'Терминал',
};
